export default function CaseStudies() {
  const cases = [
    {
      company: '大手製薬会社',
      industry: 'グローバル製薬企業',
      challenge: 'グローバル本社と日本法人で異なる安全性システムが運用されており、副作用情報の管理方法や報告プロセスが統一されていないことが課題となっていました。そのため、症例データの連携や当局への報告対応に時間と手間がかかり、安全性業務の効率化とグローバル標準への統合が求められていました。',
      solution: 'グローバル安全性システム導入プロジェクトのメンバーとして参画し、Case Processingのリードを担当。業務要件を踏まえたシステムコンフィグレーションの設計・設定、ユーザートレーニングの実施などを通じて導入を支援しました。さらに導入後は製薬会社側のメンバーとして、社内IT部門および安全性業務チームと連携しながら運用体制の整備と安定運用をサポートしました。',
      result: '日米欧を含むグローバルで統合された単一の安全性システムの導入を実現。症例情報の管理と共有が効率化され、安全性業務の生産性が向上しました。また、当局への安全性報告のスピードと正確性も大きく改善され、グローバルレベルでの安全性情報管理体制の強化に貢献しました。',
      image: 'https://public.readdy.ai/ai/img_res/917add2a83e0c06db7311d214f35aa1a.jpg',
    },
    {
      company: '中堅製薬会社',
      industry: '国内製薬メーカー',
      challenge: '安全性定期報告を新しい安全性システムへ移行する際、過去システムで管理していたデータを考慮した形で定期報告を作成する必要がありました。しかし、新旧システム間での仕様差異やデータ構造の違いにより、適切な報告書作成プロセスを確立することが課題となっていました。',
      solution: '新システムの定期報告機能の仕様と既存の安全性業務プロセスを詳細に分析し、Gap分析を実施。業務要件を満たすための設定方法や運用方法を整理し、システム設定および運用設計の最適化を支援しました。',
      result: '新しい安全性システムから定期報告を適切に出力できる環境を構築し、当局への報告業務を円滑に実施できる体制を確立しました。システム移行後も安定した安全性報告業務を継続できる基盤を整備することができました。',
      image: 'https://readdy.ai/api/search-image?query=Pharmaceutical%20quality%20control%20laboratory%20with%20scientists%20working%20on%20modern%20equipment%20professional%20clean%20room%20environment%20representing%20successful%20quality%20management%20implementation%20blue%20and%20white%20theme&width=500&height=350&seq=case-002&orientation=landscape',
    },
    {
      company: 'システムベンダー会社',
      industry: 'ITソリューション企業',
      challenge: 'MRが副作用情報を入力するための入力支援ツールの提供を検討していましたが、安全性業務に関する専門知識や製薬企業の実務課題に対する理解が不足しており、製薬会社への提案や製品価値の訴求に課題がありました。',
      solution: '製薬企業における安全性業務の実務や課題を踏まえ、MR入力支援ツールのセールス活動および開発支援を実施。製薬会社の業務フローに即した機能提案や導入メリットの整理を行い、顧客に対する具体的な活用イメージを提示しました。',
      result: '製薬企業に対してツールの価値を明確に示すことができ、MR入力支援ツールの導入を決定。安全性情報の収集プロセスの効率化に貢献するソリューションとして採用されました。',
      image: 'https://readdy.ai/api/search-image?query=Modern%20IT%20solution%20company%20office%20with%20technology%20professionals%20working%20on%20software%20development%20clean%20bright%20workspace%20with%20computers%20and%20digital%20displays%20representing%20successful%20technology%20partnership&width=500&height=350&seq=case-003&orientation=landscape',
    },
  ];

  return (
    <section id="case-studies" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            導入事例
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            安全性業務を知るプロフェッショナルによるシステム導入支援
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {cases.map((caseStudy, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300"
            >
              <div className="w-full h-56 overflow-hidden">
                <img
                  src={caseStudy.image}
                  alt={caseStudy.company}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-8">
                <div className="mb-4">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">
                    {caseStudy.company}
                  </h3>
                  <span className="inline-block px-3 py-1 bg-teal-50 text-teal-700 rounded-full text-sm font-medium">
                    {caseStudy.industry}
                  </span>
                </div>
                <div className="space-y-4">
                  <div>
                    <h4 className="text-sm font-bold text-gray-700 mb-1">課題</h4>
                    <p className="text-sm text-gray-600">{caseStudy.challenge}</p>
                  </div>
                  <div>
                    <h4 className="text-sm font-bold text-gray-700 mb-1">ソリューション</h4>
                    <p className="text-sm text-gray-600">{caseStudy.solution}</p>
                  </div>
                  <div>
                    <h4 className="text-sm font-bold text-gray-700 mb-1">成果</h4>
                    <p className="text-sm text-teal-700 font-medium">{caseStudy.result}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}